export class GalleryGroup {
    ID:number;
CLIENT_ID:number;
NAME:string;
SEQUENCE_NO:number;
STATUS:boolean=true;

}